import { NavLink } from "react-router-dom"
import PropTypes from "prop-types"
import classNames from "classnames"
import { toLower } from "lodash"
import NewFeature from "modules/new-feature"
import OPTooltip from "components/material/tooltip"
import { useSaveContextPreferences } from "hooks/preferences"

function SubLink({ id, parentId, to, label, newFeature, disabled }) {
  const saveLastSubLocationPreference = useSaveContextPreferences(`navigation.${parentId}`)

  if (disabled) {
    return <OPTooltip title={disabled}>
      <span className="link disabled">{label}</span>
    </OPTooltip>
  }

  function handleLinkClick() {
    saveLastSubLocationPreference(id)
  }

  const link = <NavLink onClick={handleLinkClick} data-test-class={`nav-${toLower(label)}`} className={({ isActive }) => classNames("link", { active: isActive })} to={to}>{label}</NavLink>

  return newFeature
    ? <NewFeature small id={newFeature.id}>{link}</NewFeature>
    : link
}

SubLink.propTypes = {
  id: PropTypes.string.isRequired,
  parentId: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  newFeature: PropTypes.object,
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}

export default SubLink
